/**
 * @fileoverview Factory function for creating audio question components
 *
 * @example
 * // Usage in component:
 * import { AudioQuestionFactory } from './AudioQuestionFactory'
 *
 * <AudioQuestionFactory question={question} />
 */

import { AudioQuestion } from './Audio'
import { CATQuestion } from './CAT'
import { QCQuestion } from './QC'

/**
 * @function AudioQuestionFactory
 * @description Factory function for creating audio question components
 * @param {Novoic.AudioQuestionProps} props - The props for the component
 * @returns {JSX.Element} The AudioQuestionFactory component
 */
export function AudioQuestionFactory(props: Novoic.AudioQuestionProps) {
    const { question } = props.question
    switch (question.category) {
        case 'qc':
            return <QCQuestion {...props} />
        case 'asrt':
            return <AudioQuestion {...props} />
        case 'cat':
            return <CATQuestion {...props} />
    }
}
